import { CardsSpadeIcon } from './CardsSpadeIcon';

/**
 * author: Nick
 * id B2DEB97A-B08E-4E10-8E24-A4AF2CF98C74
 * name cards-spade
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cards-spade.svg
 * tags
 * - Gaming / RPG 
 */
export const PokerSpadeIcon = CardsSpadeIcon;
export default PokerSpadeIcon